// extracted by mini-css-extract-plugin
export default {"root":"ErrorFooter_root__UGDSs","retryButton":"ErrorFooter_retryButton__y-uMS"};